export const handleApiError = (error) => {
    let container = document.getElementById('api-error-container');
    if (!container) {
        container = document.createElement('div');
        container.id = 'api-error-container';
        container.style.cssText = 'position:fixed;top:20px;right:20px;z-index:9999;min-width:320px;max-width:400px;';
        document.body.appendChild(container);
    }

    const alert = document.createElement('div');
    alert.className = 'alert alert-danger alert-dismissible';
    alert.style.marginBottom = '10px';

    const message = document.createElement('span');
    message.textContent = 'Something went wrong. Please try again.';

    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'btn-close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.onclick = () => alert.remove();

    alert.appendChild(message);
    alert.appendChild(closeBtn);
    container.appendChild(alert);

    setTimeout(() => {
        if (alert.parentNode) alert.remove();
    }, 5000);
};
